import api from '@/api'
import { formateDateString } from '@/util'

const SET_REPORT_LIST = 'SET_REPORT_LIST'
const SET_ANIMALFEED = 'SET_ANIMALFEED'
const SET_LOAD = 'SET_LOAD'
const SET_UPLOAD = 'SET_UPLOAD'
const SET_PLANFEED = 'SET_PLANFEED'
const SET_INOUT = 'SET_INOUT'

const SET_FILTERS = 'SET_FILTERS'
const RESET_FILTERS = 'RESET_FILTERS'
const RESET_FILTERS_CHART = 'RESET_FILTERS_CHART'

const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT'

const RESETED_FILTERS = {
  planned_on_before: formateDateString(new Date().toISOString()),
  planned_on_after: formateDateString(new Date().toISOString()),
  animal_type: [],
  group: [],
  ration: [],
  worker: [],
  loading: [],
  status: [],
  // loaded_time_min: null,
  // loaded_time_max: null,
}

const COMPARE_FILTERS = (filters, toFilters) => {
  for (const key in toFilters) {
    if (Array.isArray(toFilters[key])) {
      if (filters[key] && filters[key].length !== toFilters[key].length) {
        return false
      }
    } else {
      if (filters[key] && filters[key] !== toFilters[key]) {
        return false
      }
    }
  }
  return true
}

export default {
  namespaced: true,

  state () {
    return {
      reportsList: [],
      animalfeed: [],
      load: [],
      upload: [],
      planfeed: [],
      inout: [],
      filters: {},
      totalCount: 0,
      hasFilters: false
    }
  },

  getters: {
    reportsList: (state) => state.reportsList,
    animalfeed: (state) => state.animalfeed,
    load: (state) => state.load,
    upload: (state) => state.upload,
    planfeed: (state) => state.planfeed,
    inout: (state) => state.inout,
    filters: (state) => state.filters,
    hasFilters: (state) => state.hasFilters,
    totalCount: (state) => state.totalCount
  },

  mutations: {
    [SET_REPORT_LIST] (state, data) {
      state.reportsList = data
    },

    [SET_ANIMALFEED] (state, data) {
      state.animalfeed = data
    },

    [SET_LOAD] (state, data) {
      state.load = data
    },

    [SET_UPLOAD] (state, data) {
      state.upload = data
    },

    [SET_PLANFEED] (state, data) {
      state.planfeed = data
    },

    [SET_INOUT] (state, data) {
      state.inout = data
    },

    [SET_FILTERS] (state, filters) {
      state.filters = filters
      state.hasFilters = !COMPARE_FILTERS(state.filters, RESETED_FILTERS)
    },

    [RESET_FILTERS] (state) {
      state.filters = {
        farm: state.filters.farm,
        planned_on_before: formateDateString(new Date().toISOString()),
        planned_on_after: formateDateString(new Date().toISOString())
      }
      state.hasFilters = !COMPARE_FILTERS(state.filters, RESETED_FILTERS)
    },
    [RESET_FILTERS_CHART] (state) {
      state.filters = {
        farm: state.filters.farm,
        planned_on_before: null,
        planned_on_after: null,
        animal_type: [],
        group: [],
      }
      state.hasFilters = !COMPARE_FILTERS(state.filters, RESETED_FILTERS)
    },

    [SET_TOTAL_COUNT] (state, count) {
      state.totalCount = count
    }
  },

  actions: {
    async getReportList ({ commit, state }, params = {}) {
      for (const key in params) {
        state.filters[key] = params[key]
      }
      const filters = {}
      for (const key in state.filters) {
        filters[key] = state.filters[key]
      }
      const { data } = await api.reports.list(filters)
      commit(SET_REPORT_LIST, data)
    },

    async makeReport ({ state }, link, params = {}) {
      for (const key in params) {
        state.filters[key] = params[key]
      }
      const filters = {}
      for (const key in state.filters) {
        filters[key] = state.filters[key]
      }
      const { data } = await api.reports.make(link, filters)
      return data
    },

    async getAnimalfeed ({ commit, state }, params = {}) {
      for (const key in params) {
        state.filters[key] = params[key]
      }
      const filters = {}
      for (const key in state.filters) {
        filters[key] = state.filters[key]
      }
      const { data, count } = await api.reports.animalfeed.list(filters)
      commit(SET_ANIMALFEED, data)
      commit(SET_TOTAL_COUNT, count)
    },

    async getLoad ({ commit, state }, params = {}) {
      for (const key in params) {
        state.filters[key] = params[key]
      }
      const filters = {}
      for (const key in state.filters) {
        filters[key] = state.filters[key]
      }
      const { data, count } = await api.reports.load.list(filters)
      commit(SET_LOAD, data || [])
      commit(SET_TOTAL_COUNT, count || 0)
      return { data, count }
    },

    async getUpload ({ commit, state }, params = {}) {
      for (const key in params) {
        state.filters[key] = params[key]
      }
      const filters = {}
      for (const key in state.filters) {
        filters[key] = state.filters[key]
      }
      const { data, count } = await api.reports.upload.list(filters)
      commit(SET_UPLOAD, data)
      commit(SET_TOTAL_COUNT, count)
    },

    async getPlanfeed ({ commit, state }, params = {}) {
      for (const key in params) {
        state.filters[key] = params[key]
      }
      const filters = {}
      for (const key in state.filters) {
        filters[key] = state.filters[key]
      }
      const { data, count } = await api.reports.planfeed.list(filters)
      commit(SET_PLANFEED, data)
      commit(SET_TOTAL_COUNT, count)
    },

    async getInout ({ commit, state }, params = {}) {
      for (const key in params) {
        state.filters[key] = params[key]
      }
      const filters = {}
      for (const key in state.filters) {
        filters[key] = state.filters[key]
      }
      const { data } = await api.reports.inout.list(filters)
      commit(SET_INOUT, data)
    },
    async getInoutnew ({ commit, state }, params = {}) {
      for (const key in params) {
        state.filters[key] = params[key]
      }
      const filters = {}
      for (const key in state.filters) {
        filters[key] = state.filters[key]
      }
      const { data } = await api.reports.inoutnew.list(filters)
      commit(SET_INOUT, data)
    },

    applyFilters ({ commit }, params = {}) {
      commit(SET_FILTERS, params)
    },
    applyTotal ({ commit }, count) {
      commit(SET_TOTAL_COUNT, count)
    },

    resetFilters ({ commit }) {
      commit(RESET_FILTERS)
    },
    resetFiltersChart ({ commit }) {
      commit(RESET_FILTERS_CHART)
    }
  }
}
